<template>
	<div
		v-if="visible"
		class="package-access-notice"
		:class="rootClass"
		role="status"
	>
		{{ labelPrefix }}: {{ dateLabel }}
	</div>
</template>

<script>
import { interfaceT } from "@/utils/interfaceTranslationFallbacks";
import {
	shouldShowPackageAccessNoticeFor,
	packageAccessExpiresLabel,
} from "@/utils/packageAccessNotice";

export default {
	name: "package-access-notice",
	props: {
		item: {
			type: Object,
			default: null,
		},
		variant: {
			type: String,
			default: "card",
		},
	},
	computed: {
		visible() {
			return (
				shouldShowPackageAccessNoticeFor(this.item) &&
				!!packageAccessExpiresLabel(this.item)
			);
		},
		dateLabel() {
			return packageAccessExpiresLabel(this.item);
		},
		labelPrefix() {
			return interfaceT(this, "coursePackageAccessUntil");
		},
		rootClass() {
			return `package-access-notice--${this.variant}`;
		},
	},
};
</script>

<style src="./index.scss" lang="scss" scoped></style>
